
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/autenticacion/iniciar-sesion/restablecer",
      function () {
        return require("private-next-pages/autenticacion/iniciar-sesion/restablecer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/autenticacion/iniciar-sesion/restablecer"])
      });
    }
  